import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FormStage } from '../dynamic-form/dynamic-form/dynamic-form.component';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'app-stage-editor',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './stage-editor.component.html',
  styleUrls: ['./stage-editor.component.scss']
})
export class StageEditorComponent {
  @Input() visible: boolean = false;
  @Input() editingStage: FormStage | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() save = new EventEmitter<FormStage>();

  departmentInput: string = '';

  onClose(): void {
    this.close.emit();
  }

  onSave(): void {
    if (this.editingStage && this.isValidStage()) {
      this.save.emit({ ...this.editingStage });
      this.onClose();
    }
  }

  isValidStage(): boolean {
    return !!(this.editingStage?.name?.trim());
  }

  addDepartment(): void {
    if (this.departmentInput.trim() && this.editingStage) {
      if (!this.editingStage.requiredDepartments.includes(this.departmentInput.trim())) {
        this.editingStage.requiredDepartments.push(this.departmentInput.trim());
        this.departmentInput = '';
      }
    }
  }

  removeDepartment(dept: string): void {
    if (this.editingStage) {
      this.editingStage.requiredDepartments = this.editingStage.requiredDepartments.filter(d => d !== dept);
    }
  }

  onKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.addDepartment();
    }
  }
}